'use client';

import React from 'react';
import { createMobileAwareClickHandler } from '@/helpers/mobile-redirect';
import { StyledCtaBanner } from './LandingPageGraderTool.styles';
import { trackEvent } from '@/lib/track';

export const CtaBanner = () => {
  return (
    <StyledCtaBanner>
      <div className="banner-inner">
        <h2>Ready to turn more landing page visitors into leads?</h2>
        <p>Turn that traffic into signups and sales with a customizable popup on your site. Free to build, no code.</p>
        <a
          className="banner-cta"
          href="/popup-builder/editor"
          onClick={createMobileAwareClickHandler(() => {
            try {
              trackEvent('tool_bridge_click', {
                tool: 'landing-page-grader',
                placement: 'banner',
                target: 'popup-builder-editor',
              });
            } catch (err) {
              /* analytics must never block the click */
            }
          }, '/popup-builder/editor')}
        >
          Build my popup, free →
        </a>
      </div>
    </StyledCtaBanner>
  );
};
